import React, {useEffect,useState} from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fecthSafeTyFeeds } from '../../redux/thunks';
import GoSafeSafetyUpdatesUI from "../../../../../stories/components/cars/ResultsPage/GoSafeSafetyUpdates/GoSafeSafetyUpdatesUI";
import GoSafeSafetyUpdatesLoaderUI from "../../../../../stories/components/cars/ResultsPage/Loaders/GoSafeSafetyUpdatesLoaderUI";
import { safetyFeedSelector, safetyFeedHeaderSelector } from '../../redux/selector';
import { seoSafetyFeedSelector } from '../../../SeoPage/redux/selector'
import ReactStories from '@stencil/react-stories';

export interface ISafety {
  isSeo: boolean
}

const SafetyFeeds: React.FC<ISafety> = ({ isSeo = false }) => {
  const dispatch = useDispatch();
  const [showStories, setShowStories] = useState(false);
  const [story, setStory] = useState(null);
  const safetyFeedsResults = useSelector(isSeo ? seoSafetyFeedSelector : safetyFeedSelector);
  const safetyFeedHeader = useSelector(safetyFeedHeaderSelector);
  const { node = '' } = safetyFeedsResults;
  const { h = '', sl = '' } = safetyFeedHeader;
  useEffect(() => {
    if (!isSeo) {
      dispatch(fecthSafeTyFeeds());
    }
  }, []);
  if (safetyFeedsResults?.code) return null;
  if (!(Object.keys(safetyFeedsResults)?.length)) return <GoSafeSafetyUpdatesLoaderUI />;
  return (
    <>
      <GoSafeSafetyUpdatesUI
        title={h}
        subtitle={sl}
        node={node}
        onStoryClick={(singleNode) => {
          setStory(singleNode)
          setShowStories(true)
        }}
      />
      {showStories && <ReactStories storiesData={story} open={showStories} onClose={() => setShowStories(false)} />}
    </>
  );
}

export default SafetyFeeds;